<template>
  <hm-col :id="$attrs['id']" :cols="cols">
    <v-date-picker ref="picker"
                   v-model="selectedDate"
                   :popover-content-offset="0"
                   :is-expanded="true"
                   :is-required="true"
                   :is-double-paned="true"
                   popover-visibility="focus"
                   mode="single">
      <div>
        <input type="text" name="CCC" placeholder="A">
        <input type="text" name="BBB" placeholder="B">
      </div>
    </v-date-picker>
  </hm-col>
</template>

<script>

import { isNil, trim, isArray } from 'lodash';
import HmInputMixin from '@/mixins/HmInputMixin';

export default {
  name: 'HmInputDateRange',
  mixins: [HmInputMixin],

  data() {
    return {
      selectedDate: null,
      created: false,
      formattedDate: null,
    };
  },

  watch: {
    internalValue: function () {
      this.selectedDate = this.$moment(this.internalValue, 'YYYYMMDD').toDate();
      this.formattedDate = this.$moment(this.internalValue, 'YYYYMMDD').format(this.$moment.localeData().longDateFormat('L'));
      this.$refs.picker.updateValue();
    },
    selectedDate: function () {
      if (this.created) {
        this.internalValue = this.$moment(this.selectedDate).format('YYYYMMDD');
      }
    },
  },

  created: function () {
    this.selectedDate = this.$moment(this.internalValue, 'YYYYMMDD').toDate();
    this.formattedDate = this.$moment(this.internalValue, 'YYYYMMDD').format(this.$moment.localeData().longDateFormat('L'));
    this.created = true;
  },

  mounted: function () {
  },

  methods: {
    onBlur: function () {
      if (!isNil(this.formattedDate) && !this.formattedDate.includes('.')) {
        this.internalValue = this.$moment().add(this.formattedDate, 'days').format('YYYYMMDD');
      } else {
        this.internalValue = this.$moment(this.formattedDate, this.$moment.localeData().longDateFormat('L')).format('YYYYMMDD');
      }
      this.formattedDate = this.$moment(this.internalValue, 'YYYYMMDD').format(this.$moment.localeData().longDateFormat('L'));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>

<style lang="scss">
  @import '~styles/import';

  .component__hm-input-date-range {
    .date {
      @include icon-color($middlegray);
      //@include icon-hover($text);
      @include icon-input-hover($text);
      @include icon-input-focus($text);
    }

    .hm-input__icon__wrapper {
      pointer-events: none;
      @include icon-color($middlegray);
    }

    .hm-input__icon--input-focus {
      @include icon-color($text);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmInputDateRange.vue